/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LookupRouteImport } from './routes/lookup'
import { Route as TrackingNumberRouteImport } from './routes/$trackingNumber'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrackTrackingNumberRouteImport } from './routes/track.$trackingNumber'
import { Route as LookupResultsRouteImport } from './routes/lookup.results'

const LookupRoute = LookupRouteImport.update({
  id: '/lookup',
  path: '/lookup',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackingNumberRoute = TrackingNumberRouteImport.update({
  id: '/$trackingNumber',
  path: '/$trackingNumber',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrackTrackingNumberRoute = TrackTrackingNumberRouteImport.update({
  id: '/track/$trackingNumber',
  path: '/track/$trackingNumber',
  getParentRoute: () => rootRouteImport,
} as any)
const LookupResultsRoute = LookupResultsRouteImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => LookupRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$trackingNumber': typeof TrackingNumberRoute
  '/lookup': typeof LookupRouteWithChildren
  '/lookup/results': typeof LookupResultsRoute
  '/track/$trackingNumber': typeof TrackTrackingNumberRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$trackingNumber': typeof TrackingNumberRoute
  '/lookup': typeof LookupRouteWithChildren
  '/lookup/results': typeof LookupResultsRoute
  '/track/$trackingNumber': typeof TrackTrackingNumberRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$trackingNumber': typeof TrackingNumberRoute
  '/lookup': typeof LookupRouteWithChildren
  '/lookup/results': typeof LookupResultsRoute
  '/track/$trackingNumber': typeof TrackTrackingNumberRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$trackingNumber'
    | '/lookup'
    | '/lookup/results'
    | '/track/$trackingNumber'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$trackingNumber'
    | '/lookup'
    | '/lookup/results'
    | '/track/$trackingNumber'
  id:
    | '__root__'
    | '/'
    | '/$trackingNumber'
    | '/lookup'
    | '/lookup/results'
    | '/track/$trackingNumber'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TrackingNumberRoute: typeof TrackingNumberRoute
  LookupRoute: typeof LookupRouteWithChildren
  TrackTrackingNumberRoute: typeof TrackTrackingNumberRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/lookup': {
      id: '/lookup'
      path: '/lookup'
      fullPath: '/lookup'
      preLoaderRoute: typeof LookupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$trackingNumber': {
      id: '/$trackingNumber'
      path: '/$trackingNumber'
      fullPath: '/$trackingNumber'
      preLoaderRoute: typeof TrackingNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/track/$trackingNumber': {
      id: '/track/$trackingNumber'
      path: '/track/$trackingNumber'
      fullPath: '/track/$trackingNumber'
      preLoaderRoute: typeof TrackTrackingNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lookup/results': {
      id: '/lookup/results'
      path: '/results'
      fullPath: '/lookup/results'
      preLoaderRoute: typeof LookupResultsRouteImport
      parentRoute: typeof LookupRoute
    }
  }
}

interface LookupRouteChildren {
  LookupResultsRoute: typeof LookupResultsRoute
}

const LookupRouteChildren: LookupRouteChildren = {
  LookupResultsRoute: LookupResultsRoute,
}

const LookupRouteWithChildren =
  LookupRoute._addFileChildren(LookupRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TrackingNumberRoute: TrackingNumberRoute,
  LookupRoute: LookupRouteWithChildren,
  TrackTrackingNumberRoute: TrackTrackingNumberRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
